/**
 * Копирование тикера строки §9 в буфер обмена. Чистая функция, отделённая от
 * React-обработчика: `navigator.clipboard` доступен не во всяком контексте
 * (design.md, «Риски»), и оба случая недоступности — отсутствие самого
 * `clipboard` и отказ `writeText` — обязаны свестись к одному и тому же
 * названному исходу, а не потеряться в промисе где-то в компоненте.
 */
import type { DensitySnapshot } from "@screener/protocol";
import { copyText } from "@/lib/clipboard";
import { tickerLabel } from "@/lib/labels";

export type CopyTickerOutcome = "copied" | "failed";

/**
 * Что кладётся в буфер для строки (§9 1.44, §57): база в написании биржи
 * (`exchange_base`: `1000PEPE`, `kPEPE`) и котировка; на споте через слеш
 * (`BTC/USDT`), на бессрочном слитно (`BTCUSDT`). Писатель прежней версии
 * поле не шлёт — тогда откат на приведённую базу `instrument.base`.
 * Вынесено отдельной функцией, чтобы «тикер строки» было чем проверить.
 *
 * Не `native_symbol`: формат нативного имени у каждой биржи свой, и его
 * разбор вынес бы знание о биржах в клиент. Нативное имя уходит в
 * терминал (§10).
 */
export function tickerForClipboard(row: DensitySnapshot): string {
  return tickerLabel(row.instrument, row.exchange_base);
}

export function copyTicker(
  text: string,
  clipboard: Pick<Clipboard, "writeText"> | undefined,
): Promise<CopyTickerOutcome> {
  return copyText(text, clipboard);
}
